<template>
    <div>
        <text-form-group
                v-model="data.column_one_price"
                name="column_one_price"
                label="Column One Price"
                :error="(errors.column_one_price || [])[0]"
        />
        <text-form-group
                v-model="data.column_one_label"
                name="column_one_label"
                label="Column One Label"
                :error="(errors.column_one_label || [])[0]"
        />

        <text-form-group
                v-model="data.column_two_price"
                name="column_two_price"
                label="Column Two Price"
                :error="(errors.column_two_price || [])[0]"
        />
        <text-form-group
            v-model="data.column_two_label"
            name="column_two_label"
            label="Column Two Label"
            :error="(errors.column_two_label || [])[0]"
        />

        <text-form-group
                v-model="data.column_three_price"
                name="column_three_price"
                label="Column Three Price"
                :error="(errors.column_three_price || [])[0]"
        />
        <text-form-group
            v-model="data.column_three_label"
            name="column_three_label"
            label="Column Three Label"
            :error="(errors.column_three_label || [])[0]"
        />

        <text-form-group
                v-model="data.call_to_action_text"
                name="call_to_action_text"
                label="Call to action text"
                :error="(errors.call_to_action_text || [])[0]"
        />

        <text-form-group
                v-model="data.call_to_action_url"
                name="call_to_action_url"
                label="Call to action url"
                :error="(errors.call_to_action_url || [])[0]"
        />


        <hr>

        <table class="table table-condensed">
            <thead>
            <tr>
                <th></th>

                <th>
                    Category
                </th>

                <th>
                    Label
                </th>

                <th>
                    Column 1
                </th>

                <th>
                    Column 2
                </th>

                <th>
                    Column 3
                </th>

                <th></th>
            </tr>
            </thead>

            <Draggable
                    element="tbody"
                    v-model="data.rows"
                    handle=".handle"
                    chosen-class="interval--dragging"
            >
            <tr v-for="(row, index) in data.rows">
                <td>
                    <i class="fa fa-arrows-alt handle"/>
                </td>

                <td>
                    <select-widget
                            v-model="row.category"
                            :options="[{value: 'headline', label:'Headline'}, {value: 'content', label:'Content'}]"
                            class="input-sm"
                    />
                </td>

                <td>
                    <input type="text" class="form-control input-sm" v-model="row.label">
                </td>

                <td>
                    <input v-if="row.category === 'content'" v-model="row.column_one" type="checkbox">
                </td>

                <td>
                    <input v-if="row.category === 'content'" v-model="row.column_two" type="checkbox">
                </td>

                <td>
                    <input v-if="row.category === 'content'" v-model="row.column_three" type="checkbox">
                </td>

                <td>
                    <div class="list-actions pull-right">
                        <button type="button" class="btn btn-sm" @click="removeRow(index)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                </td>
            </tr>
            </Draggable>
        </table>

        <button type="button" class="btn btn-white btn-block" style="margin-bottom: 15px;" @click="addRow">
            <i class="fa fa-plus"/> Add Row
        </button>
    </div>
</template>

<script>
    import Draggable from 'vuedraggable'
    import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {Draggable,SelectWidget, TextFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {
            addRow() {
                let rows = this.data.rows || []

                rows.push({category: 'content', column_one: true, column_two: true, column_three: true})

                this.$emit('input', {...this.value, rows})
            },

            removeRow(index) {
                let rows = this.data.rows || []

                rows.splice(index, 1)

                this.$emit('input', {...this.value, rows})
            }
        }
    }
</script>
